export default __webpack_public_path__ + "static/media/image_album.7ff195ff.svg";